import React from 'react';
import './Missing.css';

const Missing = () => {
  return (
    <div>Missing</div>
  )
}

export default Missing